var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "ShareNetwork",
        {
          attrs: {
            network: "facebook",
            url: _vm.currentFullPath,
            title: _vm.title,
          },
        },
        [_c("i", { staticClass: "lab la-facebook-f" })]
      ),
      _vm._v(" "),
      _c(
        "ShareNetwork",
        {
          attrs: {
            network: "Twitter",
            url: _vm.currentFullPath,
            title: _vm.title,
          },
        },
        [_c("i", { staticClass: "lab la-twitter" })]
      ),
      _vm._v(" "),
      _c(
        "ShareNetwork",
        {
          attrs: {
            network: "Pinterest",
            url: _vm.currentFullPath,
            title: _vm.title,
          },
        },
        [_c("i", { staticClass: "lab la-pinterest-p" })]
      ),
      _vm._v(" "),
      _c(
        "ShareNetwork",
        {
          attrs: {
            network: "LinkedIn",
            url: _vm.currentFullPath,
            title: _vm.title,
          },
        },
        [_c("i", { staticClass: "lab la-linkedin-in" })]
      ),
      _vm._v(" "),
      _c(
        "ShareNetwork",
        {
          attrs: {
            network: "Email",
            url: _vm.currentFullPath,
            title: _vm.title,
          },
        },
        [_c("i", { staticClass: "las la-envelope" })]
      ),
      _vm._v(" "),
      _c(
        "ShareNetwork",
        {
          attrs: {
            network: "WhatsApp",
            url: _vm.currentFullPath,
            title: _vm.title,
          },
        },
        [_c("i", { staticClass: "lab la-whatsapp" })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }